import React from "react";
import "../components/PoliticasDePrivacidad.css";
import Footer from "../components/Footer";

const PoliticaDePrivacidad = () => {
  return (
    <div>
      <div className="bannerPolitica">
        <h1 className="bannerPolitica-title">Política de privacidad </h1>
      </div>
      <div className="containerBannerPolitica">
        <p className="textoBannerPolitica">Protegemos tu Intimidad</p>
        <div className="containerPolitica">
          <p>
            Primus Capital Perú S.A.C., cumple con las normas que protegen el
            derecho de las personas y empresas al resguardar la información
            confidencial de sus datos, además de cumplir con las leyes sobre
            protección de datos personales en Perú, Ley N° 29733 "Ley de
            Protección de datos personales" y demás legislación peruana vigente
            aplicable sobre Protección de datos de carácter personal.
          </p>
          <p>
            <strong>
              Política Global sobre privacidad en sitio web Primus Capital
            </strong>
          </p>
          <p>
            Respetamos y nos preocupamos de la protección de datos de carácter
            personal de nuestros usuarios. Esta política refleja el valor que le
            asignamos a la confianza entregada por nuestros clientes, quienes
            comparten con nosotros su información personal y de empresa.
          </p>
          <p>
            En todo caso, la presente Política de Privacidad de Datos Personales
            no constituye un compromiso contractual entre los usuarios y Primus
            Capital, sino que cumple un fin netamente informativo y se refiere a
            la forma en que protegemos la privacidad de nuestros usuarios cuando
            se obtiene información personal en sus sitios web <span></span>
            <a
              href="https://www.primuscapital.pe/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.primuscapital.pe/
            </a>
            .
          </p>
          <p>
            El término “información personal” usado en esta Política se refiere
            a la información que identifica al usuario personalmente y a su
            empresa, ya sea en forma individual o en conjunto con otra
            información que poseemos.
          </p>
          <p>
            Esta política es aplicable, en general, a todos los sitios web
            operados directamente por Primus Capital o por cuenta de la
            Institución y sus unidades de negocios.
          </p>
          <p>
            <strong>Autorización y aceptación de las Condiciones de Uso</strong>
          </p>
          <p>
            Para todos los efectos legales y por el mero hecho de acceder al
            sitio web de Primus Capital, el usuario acepta y reconoce que ha
            revisado y que está de acuerdo con la Política de Privacidad, en lo
            que en Derecho corresponda. Será responsabilidad del usuario la
            lectura y acatamiento de la Política de Privacidad, cada vez que
            utilice nuestros sitio y productos web.
          </p>
          <p>
            Si el usuario no autorizase la obtención, uso y/o divulgación de su
            información en la forma descrita en esta Política y de acuerdo con
            las declaraciones sobre privacidad del sitio web, no deberá usar el
            sitio web de Primus Capital y, por ende Primus Capital no podrá
            brindar los servicios que ofrece.
          </p>
          <p>
            <strong>
              Finalidades para las que utilizamos sus datos personales:
            </strong>
          </p>
          <ol className="roman-list">
            <li>
              <p>
                Dar cumplimiento a las obligaciones legales y/o brindar los
                datos que por mandato sean requeridos por las autoridades
                administrativas o judiciales correspondientes;
              </p>
            </li>
            <li>
              {" "}
              <p>
                Brindar información para la adquisición o venta de los productos
                que comercializa Primus Capital, incluyendo la generación de
                usuarios y contraseñas para que el Usuario acceda a la página
                web<span> </span>
                <a
                  href="https://www.primuscapital.pe/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.primuscapital.pe/
                </a>
                <span> </span>
                y/o enlaces o plataformas de propiedad de Primus Capital para:
                a) realizar el proceso de registro como usuario a la sucursal
                virtual, b) realizar la solicitud o cotización para la
                adquisición de productos financieros c) efectuar otras
                actividades complementarias a la relación comercial;
              </p>
            </li>

            <li>
              <p>
                {" "}
                Ejecutar, gestionar y administrar la relación contractual que se
                genere como consecuencia de la suscripción de un contrato con
                Primus Capital;
              </p>
            </li>
            <li>
              <p>Gestión de cobros;</p>
            </li>
            <li>
              <p>
                Gestión administrativa, comercial, fiscal, contable o
                facturación;
              </p>
            </li>
            <li>
              {" "}
              <p>
                {" "}
                Responder a sus solicitudes o preguntas cuando se pone en
                contacto con nosotros;
              </p>
            </li>
            <li>
              {" "}
              <p>
                {" "}
                Proteger contra el fraude, identificando y tratando de evitar el
                fraude y otras actividades ilegales; atender reclamaciones y
                otras obligaciones.
              </p>
            </li>
          </ol>

          <p>
            <strong>Datos personales que se solicitan:</strong>
          </p>
          <p>
            Para llevar a cabo las finalidades indicadas es necesario que nos
            proporcione los siguientes datos personales: nombres y apellidos,
            número de documento de identidad, número de RUC, dirección de correo
            electrónico, número telefónico, dirección de domicilio, nombre de
            usuario, contraseña y otra información de registro y/o
            actualización.
          </p>
          <p>
            <strong>
              Limitaciones respecto de la obtención, uso y divulgación de
              información personal de Primus Capital:
            </strong>
          </p>
          <ul>
            <li>
              <p>
                Sólo obtendrá, usará, divulgará y transferirá la información
                personal con autorización del usuario, la cual puede ser expresa
                o implícita, dependiendo de la sensibilidad de la información
                personal, los requisitos legales aplicables y otros factores. Al
                usar el sitio web de Primus Capital o al proporcionarnos
                información personal o de su empresa, el usuario nos autoriza a
                obtener, usar y divulgar dicha información en la forma descrita
                en esta política.
              </p>
            </li>
            <li>
              <p>
                Sólo obtendrá información para los fines indicados y limitados
                al uso de la página web y/o Plataforma Fapro, evidenciando el
                principio de causalidad. La información que obtengamos será
                aquella que sea importante, adecuada y no excesiva para los
                fines deseados.
              </p>
            </li>
            <li>
              <p>
                Procesará la información personal en una forma consecuente con
                los fines para los cuales fue originalmente obtenida o para
                aquellos que el usuario hubiese aprobado posteriormente.
              </p>
            </li>
            <li>
              <p>
                Podrá compartir la información personal con sus unidades de
                negocios y con los terceros que contratamos para que nos presten
                servicios de apoyo, o que se asocian con nosotros para
                proporcionar productos y servicios a nuestros clientes e incluso
                con terceros no relacionados. En estos casos, el uso de la
                información personal proporcionada será en forma consecuente con
                los fines para los cuales fue originalmente obtenida (o para los
                fines que usted hubiese autorizado posteriormente), de acuerdo
                con las declaraciones sobre privacidad del sitio web y con las
                leyes aplicables a la protección de datos y privacidad.
              </p>
            </li>
            <li>
              <p>
                No usará la información personal para marketing directo sin
                darle la oportunidad al usuario de no recibir más correos.
              </p>
            </li>
            <li>
              <p>
                No enviará la información personal obtenida a través del sitio
                web a los intermediarios de listas de correos masivos sin
                expreso consentimiento del usuario.
              </p>
            </li>
          </ul>
          <p>
            <strong>
              Información obtenida a través nuestros sitios de Internet y cómo
              podría ser usada
            </strong>
          </p>
          <p>
            Hay 3 formas en que podemos obtener información sobre el usuario
            cuando éste accede y usa nuestros sitios web:
          </p>

          <p>- Información enviada a nosotros por navegador Web:</p>
          <p>
            Obtenemos información que es enviada a ella automáticamente por el
            navegador web del usuario. Esta información normalmente incluye la
            dirección IP del proveedor de servicios de Internet, el nombre del
            sistema operativo y el nombre y versión del navegador. La
            información que recibimos depende de las configuraciones del
            navegador.
          </p>
          <p>
            La información proporcionada por el navegador no identifica al
            usuario personalmente. Nosotros usamos esta información para crear
            estadísticas que nos ayudan a mejorar nuestro sitio haciéndolas más
            compatibles con la tecnología usada por nuestros usuarios.
          </p>

          <p>
            - Información obtenida mediante la colocación de una “Cookie” en el
            computador:
          </p>
          <p>
            Podemos obtener información instalando un “rótulo” en el disco duro
            del computador. Este rótulo se conoce como “cookie”. El sitio Primus
            Capital usa “cookies de sesión”. Una cookie de sesión se usa para
            rotular su computadora con un identificador único generado por la
            computadora cuando el usuario accede a nuestros sitios.
          </p>
          <p>
            Una cookie de sesión no identifica al usuario personalmente y expira
            al momento en que se cierra el navegador. Usamos estas cookies de
            sesión para obtener información estadística sobre las formas en que
            los visitantes usan nuestros sitios -qué páginas visitan, qué
            vínculos usan y cuánto dura la visita a cada página. Analizamos esta
            información (conocida como “datos que fluyen con el click”) en forma
            estadística para entender mejor cuáles son los intereses y
            necesidades de nuestros visitantes y así mejorar el contenido,
            servicios y la funcionalidad de nuestro sitio.
          </p>
          <p>
            También usamos “cookies persistentes”. Estas cookies no expiran
            cuando el usuario cierra el navegador; permanecen en su computadora
            hasta que él mismo los elimina. Al asignar un identificador único al
            computador podemos crear una base de datos de selecciones y
            preferencias previas y cuando es necesario obtener nuevamente dichas
            selecciones y preferencias, podemos proporcionarlas automáticamente,
            ahorrándole así trabajo y tiempo al usuario. Por ejemplo, si después
            de hacer una DIAT o DIEP el usuario necesita hacer otra, aparecerán
            algunos datos automáticamente.
          </p>
          <p>
            Si el usuario no desea recibir cookies, puede configurar su
            navegador para que los rechace o para que le avise cuando una cookie
            es colocada en su computadora. Si bien no tiene ninguna obligación
            de recibir cookies al visitar nuestros sitios, también es cierto que
            no podrá usar todas las funcionalidades del sitio si su navegador
            rechaza nuestras cookies.
          </p>

          <p>
            - Información que el usuario nos proporciona a sabiendas y
            voluntariamente:
          </p>
          <p>
            Recogemos la información que el usuario nos proporciona a sabiendas
            y voluntariamente al usar en nuestros sitios web cliente, por
            ejemplo, la información que proporciona cuando ingresa al sistema
            clientes para revisar sus transacciones, en muchos casos, esta
            información será de carácter personal.
          </p>
          <p>
            También usamos la información que obtenemos a través nuestros sitios
            web para distintos fines comerciales, tales como atención al
            cliente, prevención de fraudes, investigación de mercado,
            mejoramiento de productos y servicios y para proporcionarle un mejor
            servicio. También podemos eliminar toda la información de
            identificación personal y usar el resto para fines históricos,
            estadísticos o científicos.
          </p>

          <p>
            <strong>Seguridad de información personal</strong>
          </p>
          <p>
            La información personal será generalmente almacenada en las bases de
            datos de Primus Capital, siendo que se almacenarán en los siguientes
            bancos de datos: i) usuarios de la web, ii) clientes, iii)
            potenciales clientes y iv) quejas y reclamos.
          </p>
          <p>
            De igual forma, algunos datos personales serán mantenidas por
            nuestros proveedores de servicios. Mantenemos protecciones
            razonables para garantizar la confidencialidad, seguridad e
            integridad de su información personal, asegurando que los
            proveedores mantienen estándares óptimos de seguridad en su proceso
            de almacenamiento.
          </p>
          <p>
            Sin embargo, no podemos garantizar la seguridad de la información
            proporcionada a través de la Internet, por lo cual el usuario acepta
            y libera de responsabilidad a Primus Capital ante cualquier
            violación de seguridad que no se encuentre en capacidad o
            razonablemente en posición de Primus Capital para su protección.
          </p>
          <p>
            <strong>Vínculos con sitios Internet de terceros</strong>
          </p>
          <p>
            El sitio Primus Capital puede contener vínculos a sitios Internet de
            terceros. Estos vínculos son proporcionados a modo de servicio y
            ello no implica que avalamos las actividades o contenidos de estos
            sitios ni una asociación con sus operadores. Primus Capital no
            controla estos sitios y no se hace responsable de su contenido,
            seguridad o privacidad. Rogamos al usuario revisar las políticas
            sobre privacidad incluidas en estos sitios web antes de usarlos o
            proporcionar su información personal.
          </p>
          <p>
            <strong>Retención de información personal</strong>
          </p>
          <p>
            Primus Capital almacena la información personal obtenida a través
            del sitio web el tiempo necesario para proporcionar los servicios,
            productos e información solicitada por el usuario o en conformidad
            con el período de retención contemplado en las leyes aplicables.
          </p>
          <p>
            En consecuencia, la información personal será conservada mientras
            dure la relación contractual, posteriormente a la misma,{" "}
            <strong>Primus Capital</strong> solo realizará el tratamiento hasta
            por cinco (05) años , después de la última comunicación que se haya
            sostenido entre dicho usuario de la página web y{" "}
            <strong>Primus Capital</strong> o cuando el usuario solicite la
            cancelación o supresión de sus datos, ejerciendo sus derechos ARCO.
          </p>
          <p>
            <strong>
              Consultas sobre esta Política y nuestras Declaraciones sobre
              privacidad
            </strong>
          </p>
          <p>
            En caso de cualquier consulta respecto de esta Política o la
            Declaración sobre privacidad de nuestros sitios web, comunícate con
            nosotros al <a href="tel: +5115000504"> (01) 5000504 Anexo 400</a> o
            escríbenos a{" "}
            <a href="mailto: comunicaciones@primuscapital.pe">
              comunicaciones@primuscapital.pe
            </a>
          </p>
          <p>
            <strong>Ejercicio de derechos ARCO</strong>
          </p>
          <p>
            Puede ejercer sus derechos de acceso, rectificación, cancelación y
            oposición al tratamiento de sus datos personales, si así lo desea,
            al correo:{" "}
            <a href="mailto: csilva@primuscapital.pe">
              csilva@primuscapital.pe
            </a> {" "}o{" " }
            <a href="mailto: ksanchez@primuscapital.pe">
            ksanchez@primuscapital.pe
            </a>
          </p>
          <p>
            De considerar que no ha sido atendido en el ejercicio de sus
            derechos, podrá presentar una reclamación ante la Autoridad Nacional
            de Protección de Datos Personales, llenando el formulario publicado
            en el siguiente enlace:{" "}
            <a href="https://www.minjus.gob.pe/wp-content/uploads/2018/12/FORMULARIO-DE-PROCEDIMIENTO-TRILATERAL-DE-TUTELA.pdf">
              https://www.minjus.gob.pe/wp-content/uploads/2018/12/FORMULARIO-DE-PROCEDIMIENTO-TRILATERAL-DE-TUTELA.pdf
            </a>{" "}
            y adjuntando a él los documentos sustentatorios; los que deberá
            entregar en la Mesa de Partes del Ministerio de Justicia y Derechos
            Humanos: Calle Scipion Llona 350, Miraflores, Lima, Perú o remitir
            en versión escaneada dichos documentos sustentatorios a través de su
            Mesa de Partes Virtual:{" "}
            <a href="https://sgd.minjus.gob.pe/sgd-virtual/public/ciudadano/ciudadanoMain.xhtml">
              https://sgd.minjus.gob.pe/sgd-virtual/public/ciudadano/ciudadanoMain.xhtml
            </a>
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PoliticaDePrivacidad;
